import React from "react";
import "./Team_personal_page.css";

const Team_personal_page = () => {
  return (
    <div className="text_team">
      <h2>Team members</h2>

      <div className="photo-container">
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/florian.jpg"}
            alt="Florian Aubert"
          />
          <div className="image-text">
            <h3>Florian Aubert</h3>
            <p className="gray-text">
              Master student in Life Sciences Engineering
            </p>
            <p>Pre-Wet Lab, Wet Lab, Wiki</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/charles.jpg"}
            alt="Charles Boissier"
          />
          <div className="image-text">
            <h3>Charles Boissier</h3>
            <p className="gray-text">Bachelor student in Computer Sciences</p>
            <p>Wiki, Social Media, Wet Lab</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/charlotte.jpg"}
            alt="Charlotte Coulon"
          />
          <div className="image-text">
            <h3>Charlotte Coulon</h3>
            <p className="gray-text">
              Master student in Bio-Mechanical Engineering
            </p>
            <p>Pre-Wet Lab, Wet Lab, Education, Graphics</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/tim.jpg"}
            alt="Timothé Dufour"
          />
          <div className="image-text">
            <h3>Timothé Dufour</h3>
            <p className="gray-text">
              Bachelor student in Life Sciences Engineering
            </p>
            <p>Social Media, Wet Lab, Wiki, Sponsorship</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/maud.jpg"}
            alt="Maud Faivre D'Arcier"
          />
          <div className="image-text">
            <h3>Maud Faivre d'Arcier</h3>
            <p className="gray-text">
              Bachelor student in Life Sciences Engineering
            </p>
            <p>Sponsorship, Social Media, Wet Lab, Wiki</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/lucie.jpg"}
            alt="Lucie Huamani-Cantrelle"
          />
          <div className="image-text">
            <h3>Lucie Huamani-Cantrelle</h3>
            <p className="gray-text">
              Bachelor student in Life Sciences Engineering
            </p>
            <p>Wiki, Graphics, Wet Lab</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/matthis.jpg"}
            alt="Matthis Lugnier"
          />
          <div className="image-text">
            <h3>Matthis Lugnier</h3>
            <p className="gray-text">
              Master student in Life Sciences Engineering
            </p>
            <p>Pre-Wet Lab, Wet Lab, Education, Human Practices</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/maxime.jpg"}
            alt="Maxime Nourry"
          />
          <div className="image-text">
            <h3>Maxime Nourry</h3>
            <p className="gray-text"> Bachelor student in Microtechnics</p>
            <p>Video Game, Wiki, Wet Lab</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/cassandre.jpg"}
            alt="Cassandre Pitz"
          />
          <div className="image-text">
            <h3>Cassandre Pitz</h3>
            <p className="gray-text">
              Master student in Bio-Mechanical Engineering
            </p>
            <p>Human Practices, Education, Wet Lab, Graphics, Wiki</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/eva.jpg"}
            alt="Eva Quinto"
          />
          <div className="image-text">
            <h3>Eva Quinto</h3>
            <p className="gray-text">
              Bachelor student in Life Sciences Engineering
            </p>
            <p>Human Practices, Video Game, Wiki, Wet Lab</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/jade.jpg"}
            alt="Jade Therras"
          />
          <div className="image-text">
            <h3>Jade Therras</h3>
            <p className="gray-text">Master student in NeuroX</p>
            <p>Video Game, Human Practices, Wiki, Pre-Wet Lab</p>
          </div>
        </div>
        <div className="photo-item">
          <img
            src={"https://static.igem.wiki/teams/4888/wiki/leo.jpg"}
            alt="Leonardo Tredici"
          />
          <div className="image-text">
            <h3>Leonardo Tredici</h3>
            <p className="gray-text">
              Bachelor student in Life Sciences Engineering
            </p>
            <p>Sponsorship, Wet Lab, Video Game, Wiki</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Team_personal_page;
